import {createFeatureSelector, createSelector} from "@ngrx/store";
import {VendorState} from "./vendor.reducer";

const getVendorState = createFeatureSelector<VendorState>('vendor');

export const getVendorSuccess = createSelector(getVendorState, (state: VendorState) => state.success);

export const getVendorError = createSelector(getVendorState, (state: VendorState) => state.error);

export const getVendorDetails = createSelector(getVendorState, (state: VendorState) => state.vendor);

export const getIsStoreNameAvailable = createSelector(getVendorState, (state: VendorState) => state.isStoreNameAvailable);

export const getCategories = createSelector(getVendorState, (state: VendorState) => state.categories);

export const getProducts = createSelector(getVendorState, (state: VendorState) => state.products);

export const getVendorProduct = createSelector(getVendorState, (state: VendorState) => state.product);

export const getVendorOrders = createSelector(getVendorState, (state: VendorState) => state.orders);

export const getVendorDashboard = createSelector(getVendorState, (state: VendorState) => state.dashboard);

export const getVendorOrderInfo = createSelector(getVendorState, (state: VendorState) => state.orderInfo);

export const getReviews = createSelector(getVendorState, (state: VendorState) => state.reviews);

export const getwallet = createSelector(getVendorState, (state: VendorState) => state.wallet);

export const getWalletTransaction = createSelector(getVendorState, (state: VendorState) => state.walletTransaction);

export const getPayoutData = createSelector(getVendorState, (state: VendorState) => state.payout);

export const getBillingAndBankData = createSelector(getVendorState, (state: VendorState) => state.bankAndBillingData);

export const getPolicyData = createSelector(getVendorState, (state: VendorState) => state.policy);

export const getVendorAdsDetails = createSelector(getVendorState, (state: VendorState) => state.adsDetails);

export const getCurrencyData = createSelector(getVendorState, (state: VendorState) => state.currencyData);

export const getAdsWalletTransaction = createSelector(getVendorState, (state: VendorState) => state.adsWalletTransaction);

export const getSubscriptionPlanList = createSelector(getVendorState, (state: VendorState) => state.subscriptionPlanList);

export const getActiveSubscribedPlan = createSelector(getVendorState, (state: VendorState) => state.activeSubscribedPlan);

export const getSubscriptionTransaction = createSelector(getVendorState, (state: VendorState) => state.subscriptionTransaction);

export const getReviewCount = createSelector(getVendorState, (state: VendorState) => state.reviewCount);

export const getNegotiations = createSelector(getVendorState, (state: VendorState) => state.negotiations);

export const getProposals = createSelector(getVendorState, (state: VendorState) => state.proposals);

export const getProposal = createSelector(getVendorState, (state: VendorState) => state.proposal);

export const getPaymentIntent = createSelector(getVendorState, (state: VendorState) => state.paymentIntent);

export const getGeneratedDescription = createSelector(getVendorState, (state: VendorState) => state.description);
